<template>
  <p>Dash view</p>
</template>
<script>
export default {
  name: "DashboardView"
}
</script>
